/**
 * Data Processing for read/write Mydex data operations
 * 
 */
export const DataProcessing = (function() {

    var _pds_read_endpoint = '/pds-read';
    var _pds_write_endpoint = '/pds-write';
    var _pds_update_endpoint = '/pds-update';
    var _pds_instance = 0;
    var _is_new_dataset = false;

    var load = {
      
        /**
         * Loop each of the elements with class `pds-form`
         * For each nested input/select/
         */
        pds: function () {
            /**
             * Try to get the mydexID from the URL path
             * In apps that read/write from a PDS other than the
             * session user, we use the mydexID from the URL 
             * and check on the backend with MACM that the member has access
             * to read from the members mydexID.  
             */
            var mydexID = Util.getPathParameterByName('citizen');

            const urlParams = new URLSearchParams(window.location.search);
            var instance = urlParams.get('instance');
            if(instance) {
              _pds_instance = instance;
            }

            if (window.location.pathname.includes('/maa')) {
                _pds_read_endpoint = '/maa/pds-read';
                _pds_write_endpoint = '/maa/pds-write';
                _pds_update_endpoint = '/maa/pds-update';
            }

            $('.pds-form').each(function () {
              
                // loop through each child input element and then add event handler
                var dataset = $(this).attr("id");
                var noread = $(this).hasClass("no-read");
                if (!noread){
                    load.displayAllDatasets(_pds_read_endpoint, dataset, mydexID, _pds_instance);
                }
            
                $(this).find('input').change(function () {
                    var node = this.parentNode.parentNode;
                    Submit.dataset(_pds_update_endpoint, node, mydexID);

                });
                $(this).find('select').change(function () {
                    var node = this.parentNode.parentNode;
                    Submit.dataset(_pds_update_endpoint, node, mydexID);
                });
                $(this).find('textarea').change(function () {
                    var node = this.parentNode.parentNode;
                    Submit.dataset(_pds_update_endpoint, node, mydexID);
                });
            });
            $('.pds-table').each(function () {
                var curTable = $(this).attr("id");
                load.displayTables(_pds_read_endpoint, curTable);
            });
            $('.pds-instance').each(function () {
              $(this).click(function () {
                // Get the dataset and the instance from the link we clicked
                var dataset = $(this).attr("data-dataset");
                var instance = $(this).attr("data-instance");
                // Load the data from PDS and display
                load.displayAllDatasets(_pds_read_endpoint, dataset, mydexID, instance);
              });
            });
        },

        displayAllDatasets: function (post_url, dataset, mydexID, instance) {

            /**
             * If MydexID is not null add to the POST data
             */
            var post_data = {
              dataset: dataset,
              type: 'transactional',
              instance: instance
            };
            if(mydexID !== null){
                post_data.mydexID = mydexID;
            }

            var csrf = Util.getCSRF();
            $.ajax({
                url: post_url,
                type: 'post',
                dataType: 'json',
                headers: { 'isAPI': true,  'x-csrf-token': csrf },
                data: post_data,
                statusCode: {
                    403: function(response) {
                            load.setDenied(response, dataset);
                    },         
              }
            }).done(function (response) { //

                

                if (response.error == "Requested data not available (not set).") {
                    console.log("Error", dataset);
                }
                else {

                    /**
                     * Get the the datasetID (the ID of the PDS record) of the dataset.
                     * We get the 0 because we will get 1 record
                     */
                    var datasetID = parseInt(
                        Object.keys(response)[0]
                    );

                    //loops over complete dataset and sets all values on the for
                    for (var key in response[datasetID]) {

                        var value = response[datasetID][key];
                        var element = document.getElementById(key + "ID");

                        if (element !== null) {
                            
                            if (element.type === 'date') {
                                if(value != "" && value != 0) {
                                    element.value = load.convertDate(value);
                                } 
                            } else {
                                element.value = value;
                            }
                            /**
                             * Set the dataset instance that we read from on the element
                             * so that we know what instance to write back to on update.  
                             */
                            if(element.parentNode.parentNode.getAttribute("data-dataset-id") != datasetID ) {
                              element.parentNode.parentNode.setAttribute("data-dataset-id", datasetID);
                            }

                        }

                    }
                }

            }).fail(function (e) {
                console.log(e);
            });



        },

        displayTables: function (post_url, curTable) {

            var dataset = curTable;
            dataset = dataset.replace('table_', '');
            $.ajax({
                url: post_url,
                type: 'post',
                dataType: 'json',
                data: {
                    dataset: dataset,
                    type: 'transactional'
                },
            }).done(function (response) { //
                console.log(response);
                load.addTableData(response, curTable);


            }).fail(function (e) {
                console.log(e);
            });



        },
        addTableData: function (data, tableID) {

            var columnsArray = [];
            var columnsArrayMachine = [];
            //get column names and add to array
            var cols = document.getElementById(tableID);
            var colCount = $('#' + tableID + " td").length;
            for (var i = 0; i < colCount; i++) {
                var colNum = cols.getElementsByTagName("td");
                var f = { title: colNum[i].innerText };
                columnsArray.push(f);
                var colID = colNum[i].id;
                colID = colID.replace('-td', '');
                columnsArrayMachine.push(colID);
            }

            var arr = [];
            var count = 0;

            for (var key in data) {
                var valueArray = [];
                arr[count] = [];

                for (var v in columnsArrayMachine) {

                    for (var val in data[key]) {

                        if (val.trim() == columnsArrayMachine[v].trim()) {

                            var col = document.getElementById(val + "-td");
                            var x = col.getAttribute("data-type");
                            if (data[key][val] == "") {
                                valueArray.push("test");
                            }
                            else {

                                if (x == "date") {
                                    var test = load.convertDate(data[key][val]);
                                    valueArray.push(test);

                                } else {
                                    valueArray.push(data[key][val])
                                }
                            }

                        }

                    }

                }
                arr[count] = valueArray;
                count++;
            }

            $('#' + tableID).DataTable({
                data: arr,
                columns: columnsArray,
                response: true
            });

        },
        convertDate: function (date) {
            var unixtimestamp = date;
            var today = new Date(unixtimestamp * 1000);
            date = today.getFullYear() + '-' + ('0' + (today.getMonth()+1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2);
            return date;
        },

        setDenied: function (response, dataset) {
          $(document.getElementById(dataset)).html(response['responseText']);
        },

    }
    var Submit = {

        dataset: function (post_url, node, mydexID = null) {


            if (node.getAttribute("data-dataset-id") === null){
                var json_form_data = PDS.pds.serialize(node);
                var parsed_form_data = JSON.parse(json_form_data);
                delete parsed_form_data['dataset'];
                var post_data = {
                    formData: parsed_form_data, //Encode form elements for submission,
                    dataset: node.name
                  };
                  post_url = _pds_write_endpoint

            }else{
                var post_data = {
                    data: PDS.pds.serialize(node), //Encode form elements for submission,
                    dataset: node.name,
                    datasetID: node.getAttribute("data-dataset-id"),
                  };
            }


            if(mydexID !== null){
                post_data.mydexID = mydexID;
            }
            var csrf = Util.getCSRF();
            $.ajax({
                url: post_url,
                type: 'post',
                headers: {'x-csrf-token': csrf},
                data: post_data
            }).done(function (response) { //
                console.log(response);
            }).fail(function (e) {
                console.log(e);
            });

        },
    }

    return {
        load: load
    }

}());
